import script from "./SubscriptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionModal.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionModal.vue?vue&type=style&index=0&id=84b215d6&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84b215d6"]])

export default __exports__